import './i18n';
import { ThemeProvider } from './hooks/useTheme';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import MemberLogin from './pages/MemberLogin';
import PortalDashboard from './pages/PortalDashboard';
import PortalSetup from './pages/PortalSetup';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import MemberManagement from './pages/MemberManagement';
import CapturedAds from './pages/CapturedAds';
import AdminSystemMonitor from './pages/AdminSystemMonitor';
import PatternSettings from './pages/PatternSettings';
import TrafficCapturePage from './pages/TrafficCapturePage';
import ClassifierSettings from './pages/ClassifierSettings';
import EnrichmentMonitor from './pages/EnrichmentMonitor';
import MemberAppDownload from './pages/MemberAppDownload';
import ConnectionCheck from './pages/ConnectionCheck';
import ResearchDashboard from './pages/ResearchDashboard';
import ResearchActivity from './pages/ResearchActivity';
import Reports from './pages/Reports';
import GamblingAnalysis from './pages/GamblingAnalysis';
import PostSurveyAnalysis from './pages/PostSurveyAnalysis';
import DisplayTimeVerification from './pages/DisplayTimeVerification';
import AIJudgeOverrides from './pages/AIJudgeOverrides';
import AdminUserManagement from './pages/AdminUserManagement';
import AdminLayout from './components/AdminLayout';

function App() {
  return (
    <ThemeProvider>
    <BrowserRouter>
      <Routes>
        {/* Member Routes */}
        <Route path="/" element={<MemberLogin />} />
        <Route path="/portal/dashboard" element={<PortalDashboard />} />
        <Route path="/portal/setup" element={<PortalSetup />} />
        <Route path="/portal/app-download" element={<MemberAppDownload />} />
        <Route path="/check" element={<ConnectionCheck />} />

        {/* Admin Login (no sidebar) */}
        <Route path="/admin" element={<AdminLogin />} />

        {/* Admin Routes (with sidebar layout) */}
        <Route element={<AdminLayout />}>
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/members" element={<MemberManagement />} />
          <Route path="/admin/captured-ads" element={<CapturedAds />} />
          <Route path="/admin/system-monitor" element={<AdminSystemMonitor />} />
          <Route path="/admin/pattern-settings" element={<PatternSettings />} />
          <Route path="/admin/traffic-capture" element={<TrafficCapturePage />} />
          <Route path="/admin/classifier-settings" element={<ClassifierSettings />} />
          <Route path="/admin/enrichment-monitor" element={<EnrichmentMonitor />} />
          <Route path="/admin/research" element={<ResearchDashboard />} />
          <Route path="/admin/research/activity" element={<ResearchActivity />} />
          <Route path="/admin/reports" element={<Reports />} />
          <Route path="/admin/gambling-analysis" element={<GamblingAnalysis />} />
          <Route path="/admin/post-survey-analysis" element={<PostSurveyAnalysis />} />
          <Route path="/admin/display-time-verification" element={<DisplayTimeVerification />} />
          <Route path="/admin/ai-judge" element={<AIJudgeOverrides />} />
          <Route path="/admin/admin-users" element={<AdminUserManagement />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
